import { render, staticRenderFns } from "./deliveryOrder.vue?vue&type=template&id=70a3621d&"
import script from "./deliveryOrder.vue?vue&type=script&lang=js&"
export * from "./deliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./deliveryOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports